import { render, staticRenderFns } from "./Ai.vue?vue&type=template&id=53460577&scoped=true"
import script from "./Ai.vue?vue&type=script&lang=js"
export * from "./Ai.vue?vue&type=script&lang=js"
import style0 from "./Ai.vue?vue&type=style&index=0&id=53460577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53460577",
  null
  
)

export default component.exports